<header
  class="header-container flex justify-between items-center px-6 py-3 bg-white"
  [ngClass]="{ 'header-sidebar-expanded': isSideNavCollapsed }"
>
  <!-- Left section: mobile hamburger + logo -->
  <div class="header-left-section flex items-center gap-3">
    <!-- Mobile-only hamburger toggler -->
    <button
      class="mobile-menu-toggler"
      (click)="toggleSideNav()"
      aria-label="Open menu"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Logo -->
    <img
      src="assets/images/new-images/logo-2.png"
      class="header-image cursor-pointer"
      [ngClass]="{ 'hide-on-desktop': isSideNavCollapsed }"
      routerLink="/dashboard"
    />
  </div>

  <div class="header-right-section flex items-center space-x-4">
    <!-- Google Translate -->
    <div id="google_translate_element"></div>

    <!-- Notifications Dropdown -->
    <!-- <div (click)="gotoNotificationPage()">
      <a
      *hasPermissions="[
        Permissions.VIEW_IN_APP_NOTIFICATION,
      ]"
      class="header-notification-dropdown relative cursor-pointer"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="notificationMenu"
    >
      <nz-badge
        [nzCount]="notificationStats?.unread || 0"
        [nzOverflowCount]="99"
      >
        <mat-icon class="text-primary text-2xl">notifications</mat-icon>
      </nz-badge>

    </a>
     </div> -->

    <nz-dropdown-menu #notificationMenu="nzDropdownMenu">
      <!-- <div class="w-96 max-h-[520px] bg-white shadow-xl rounded-lg flex flex-col">


        <div class="flex justify-between items-center px-3 py-2 border-b">
          <button mat-button color="primary" (click)="markAllAsRead()">
            Mark all read
          </button>

          <button mat-button color="primary" routerLink="/notifications">
            See more
          </button>
        </div>


        <mat-tab-group
          (selectedIndexChange)="onTabChange($event)"
          class="notification-tabs"
        >
          <mat-tab label="All"></mat-tab>
          <mat-tab label="Unread"></mat-tab>
        </mat-tab-group>


        <div class="px-3 py-2 border-b bg-gray-50">
          <app-searchable-select
            class="notification-filter"
            [label]="'Type'"
            [required]="false"
            [options]="notificationTypeOptions"
            [showDefaultOption]="true"
            (selectionChangeEmit)="onNotificationTypeChange($event)"
          >
          </app-searchable-select>
        </div>


        <div class="flex-1 overflow-y-auto">
          <ul nz-menu>

            <li
              *ngFor="let item of activeTab === 'UNREAD' ? unreadNotifications : allNotifications"
              nz-menu-item
              class="flex items-start gap-3 px-3 py-2 hover:bg-gray-100 cursor-pointer"
              (click)="openNotification(item)"
            >

              <mat-icon
                *ngIf="item.type === 'LOAN_APPROVAL'"
                class="text-primary mt-1"
              >
                account_balance
              </mat-icon>

              <mat-icon
                *ngIf="item.type === 'REPAYMENT_APPROVAL'"
                class="text-green-500 mt-1"
              >
                payment
              </mat-icon>

              <mat-icon
                *ngIf="item.type !== 'LOAN_APPROVAL' && item.type !== 'REPAYMENT_APPROVAL'"
                class="text-blue-500 mt-1"
              >
                notifications
              </mat-icon>


              <div class="flex flex-col">
                <span
                  class="text-sm"
                  [class.font-semibold]="item.status === 'UNREAD'"
                >
                  {{ item.title }}
                </span>

                <span class="text-xs text-gray-500 line-clamp-2">
                  {{ item.message }}
                </span>

                <span class="text-[10px] text-gray-400 mt-1">
                  {{ item.createdAt | date:'short' }}
                </span>
              </div>
            </li>

            <li
              *ngIf="(activeTab === 'UNREAD' ? unreadNotifications : allNotifications).length === 0"
              nz-menu-item
              class="text-center text-gray-400 py-4"
            >
              No notifications
            </li>

          </ul>
        </div>
      </div> -->
    </nz-dropdown-menu>

    <!-- User / Avatar Dropdown  -->
    <div class>
      <a
        class="header-dropdown-section cursor-pointer flex items-center space-x-2"
        nz-dropdown
        nzTrigger="click"
        [nzDropdownMenu]="menu"
      >
        <img
          class="rounded-full w-8 h-8"
          [src]="
            u?.photo
              ? baseUrl + 'api/v1/photo/' + u.photo
              : 'assets/images/system-images/avatar.png'
          "
        />
        <b class="caret"></b>
      </a>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul class="rounded-xl bg-white shadow-lg" nz-menu nzSelectable>
          <li
            class="text-[11px] flex justify-between items-center font-semibold px-3 py-2 hover:bg-gray-100"
            nz-menu-item
          >
            <p routerLink="/settings" class="dropdown-item" i18n="@@settings">
              Settings
            </p>
            <mat-icon class="text-primary text-[16px] mt-1">settings</mat-icon>
          </li>

          <li
            class="text-[11px] flex justify-between items-center font-semibold px-3 py-2 hover:bg-gray-100"
            nz-menu-item
            (click)="logout()"
          >
            <p class="dropdown-item" i18n="@@log_out">Logout</p>
            <mat-icon class="text-tertiary text-[16px] mt-1">logout</mat-icon>
          </li>

          <p class="px-3 py-2 text-gray-400 text-[11px]" id="clickedByUser">
            {{ u?.email | titlecase }}
          </p>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>
</header>
